import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  FormControl,
  InputLabel,
  Button,
  TextField,
  Select,
  MenuItem,
  Typography,
  Slider,
  Card,
  makeStyles,
} from '@material-ui/core';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from '../firebase/firebaseConfig';

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: '5%',
    padding: '10px',
  },
  form: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '25px 10px',
    justifyItems: 'stretch',
    alignItems: 'center',
    '@media (max-width: 610px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'inherit',
      paddingLeft: '20px',
      paddingRight: '20px',
    },

    marginBottom: '20px',
  },
  title: {
    textAlign: 'center',
  },
  phone: {
    '@media (max-width: 363px)': {
      width: '100%',
    },
  },
  button: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  error: {
    textAlign: 'center',
    fontStyle: 'italic',
    color: 'red',
  },
}));

const SignUp = ({ handleShowSignIn, lang }) => {
  const classes = useStyles();
  const history = useHistory();

  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    dob: new Date().toDateString(),
    lang: lang === 'en' ? 'English' : 'Español',
    password: '',
    salsaLevel: 0,
    bachataLevel: 0,
    referredBy: 'N/A',
    classStats: {
      classesRemaining: 0,
      classesTaken: 0,
    },
    // classes: 0,
  });
  const [errorMsg, setErrorMsg] = useState('');

  const levelMarks = [
    {
      value: 10,
      label: lang === 'en' ? 'Beg.' : 'Bajo',
    },
    {
      value: 40,
      label: lang === 'en' ? 'Inter.' : 'Intermedio',
    },
    {
      value: 70,
      label: lang === 'en' ? 'Adv.' : 'Avanzado',
    },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    //Create a new user
    try {
      //create an account
      const userCredential = await firebase
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password);
      const authUser = userCredential.user;

      //Create a new user in firebase from this
      // const {
      //   name,
      //   email,
      //   phone,
      //   dob,
      //   lang,
      //   password,
      //   salsaLevel,
      //   bachataLevel,
      //   referredBy,
      //   classes,
      // } = user;
      // console.log([name, email, phone, dob, lang, password]);
      await firebase
        .firestore()
        .collection('class_accounts')
        .doc(authUser.uid)
        .set({
          ...user,
          uid: authUser.uid,
        });
      // await firebase
      //   .firestore()
      //   .collection('class_accounts')
      //   .doc(authUser.uid)
      //   .set({
      //     name,
      //     email,
      //     phone,
      //     dob,
      //     lang,
      //     salsaLevel,
      //     bachataLevel,
      //     referredBy,
      //     classes,
      //   });
      history.push({ pathname: '/account', state: { userUID: authUser.uid } });
    } catch (error) {
      console.error(
        'There was an error creating a new user or writing to firestore',
        error
      );
      setErrorMsg(error.message);
    }
  };

  return (
    <Card className={classes.card}>
      <h1 className={classes.title}>Please Sign Up</h1>
      <form className={classes.form} autoComplete='off' onSubmit={handleSubmit}>
        <TextField
          style={{ gridColumn: '1 / span 1' }}
          value={user.name}
          onChange={(e) => setUser({ ...user, name: e.target.value })}
          required
          label={lang === 'en' ? 'Name' : 'Nombre'}
          variant='outlined'
        />
        <MuiPickersUtilsProvider
          style={{ gridColumn: '2 / span 1' }}
          locale={lang === 'es' ? esLocale : null}
          utils={DateFnsUtils}
        >
          <KeyboardDatePicker
            margin='normal'
            label={lang === 'en' ? 'Date of Birth' : 'Fecha De Nacimiento'}
            format='MM/dd/yyyy'
            value={user.dob}
            onChange={(newDate) =>
              setUser({ ...user, dob: newDate && newDate.toDateString() })
            }
            // KeyboardButtonProps={{
            //   'aria-label': 'change date',
            // }}
          />
        </MuiPickersUtilsProvider>
        <TextField
          value={user.email}
          onChange={(e) => setUser({ ...user, email: e.target.value })}
          required
          label={lang === 'en' ? 'Email' : 'Correo Electrónico'}
          variant='outlined'
        />
        <TextField
          value={user.password}
          onChange={(e) => setUser({ ...user, password: e.target.value })}
          type='password'
          required
          label={lang === 'en' ? 'Password' : 'Contraseña'}
          variant='outlined'
        />
        <PhoneInput
          className={classes.phone}
          inputProps={{
            name: 'Enter Your Phone Number',
          }}
          country={'us'}
          value={user.phone}
          onChange={(phone) => setUser({ ...user, phone })}
        />

        {/* Preferred Language */}

        <FormControl>
          <InputLabel id='signup-lang-label'>
            {lang === 'en' ? 'Language Preference' : 'Idioma De Preferencia '}
          </InputLabel>
          <Select
            value={user.lang}
            onChange={(e) => setUser({ ...user, lang: e.target.value })}
            labelId='signup-lang-label'
          >
            <MenuItem value={'English'}>English</MenuItem>
            <MenuItem value={'Español'}>Español</MenuItem>
          </Select>
        </FormControl>

        <div>
          <Typography gutterBottom>
            {lang === 'en' ? 'Salsa Level' : 'Nivel de Salsa'}
          </Typography>
          <Slider
            value={user.salsaLevel}
            onChange={(e, newValue) =>
              setUser({ ...user, salsaLevel: newValue })
            }
            //getAriaValueText={valuetext}
            //aria-labelledby='discrete-slider-always'
            step={10}
            marks={levelMarks}
            // valueLabelDisplay='on'
          />
        </div>
        <div>
          <Typography gutterBottom>
            {lang === 'en' ? 'Bachata Level' : 'Nivel de Bachata'}
          </Typography>
          <Slider
            value={user.bachataLevel}
            onChange={(e, newValue) =>
              setUser({ ...user, bachataLevel: newValue })
            }
            //getAriaValueText={valuetext}
            //aria-labelledby='discrete-slider-always'
            step={10}
            marks={levelMarks}
            // valueLabelDisplay='on'
          />
        </div>

        <TextField
          value={user.referredBy}
          onChange={(e) => setUser({ ...user, referredBy: e.target.value })}
          required
          label={
            lang === 'en' ? 'Who referred you?' : 'Alguien te nos recomendó?'
          }
        />
        <Button
          className={classes.button}
          type='submit'
          variant='contained'
          color='secondary'
        >
          {lang === 'en' ? 'Sign Up' : 'Registrarse'}
        </Button>
      </form>
      <p className={classes.error}>{errorMsg}</p>
      <Button
        className={classes.button}
        color='secondary'
        onClick={handleShowSignIn}
      >
        {lang === 'en' ? 'Sign In' : 'Iniciar Sesión'}
      </Button>
    </Card>
  );
};

export default SignUp;
